/**
 * config.js - Frontend runtime configuration.
 *
 * The React app no longer talks directly to Azure AD. Authentication
 * is handled by the local Express backend, and Business Central is
 * reached through the backend's OAuth2 client-credentials proxy
 * (/api/proxy/bc/*).
 *
 * Environment variables (vite loads .env at the project root):
 *   VITE_API_BASE                  - URL of the backend (default: same origin)
 *   VITE_BC_BASE_URL              - Informational only. Real BC calls go
 *                                   through /api/proxy/bc. Useful for UI
 *                                   links that open BC.
 *   VITE_BC_COMPANY_ID            - Optional, used to deep-link into a
 *                                   specific BC company.
 */

/* Backend (login + BC proxy) - defaults to same origin for production */
export const API_BASE =
  (import.meta.env && import.meta.env.VITE_API_BASE) || "";

/* Business Central - shown in the UI, real calls go through the proxy */
export const BC_PUBLIC = {
  baseUrl:
    (import.meta.env && import.meta.env.VITE_BC_BASE_URL) || "",
  environment:
    (import.meta.env && import.meta.env.VITE_BC_ENVIRONMENT) || "",
  companyId:
    (import.meta.env && import.meta.env.VITE_BC_COMPANY_ID) || "",
};
